import { BaseDraw } from './BaseDraw';
import {FREE_DRAW_TYPE, FREE_FORM_THICKNESS_POPUP_ID, MEASURE_UNITS} from "../../../../../constants";
import {getLockPointPos} from "../../../helpers/freeDrawHelper";
import {createShapeFromFreeDrawPoints} from "../../../../../helpers/freeDrawHelper";
import RenderFreeForm from "../../../helpers/renderFreeForm";
import EventManager from "../../../store/sqftEventManager";
import {
  getFontsize,
  getMousePositionOnField,
  getPointField,
  parseImperialFractionToDecimal
} from "../../../../../helpers/sqftHelper";
import COLOR_THEMES from "../../../store/colorThemes";
import sqftConfig from "../../../store/sqftConfig";
import ChangeValuePopup from "../../../../popup/models/ChangeValuePopup";
import store from "../../../../../../../store";
import {
  addChangeValuePopup,
  changeValuePopup,
  deleteChangeValuePopup
} from "../../../../../../../actions/sqftMenuFunctions";
import workspace from "../../workspace";
import {getOffsetShapePoints} from "./helpers/freeFormHelper";
import DrawImage from "../../workspace/textBox/draw/drawImage";
import config from "../../../store/sqftConfig";

export class ShapeFreeForm extends BaseDraw {
  constructor() {
    super();
    this.state.drawType = FREE_DRAW_TYPE.shapeFreeForm;
    this.minDistanceBetweenFreeDrawPoints = 15;
  }

  getThicknessValue = () => {
    let thicknessPopup = this.getThicknessPopup();

    return thicknessPopup.value / sqftConfig.getMeasureMultiplier();
  }

  drawShape = (mousePos) => {
    if (this.checkIfFirstPointHovered()) {
      this.drawFinish();
      return;
    }

    const point = this.getPointFromMousePosition(mousePos);
    //update min distance between points

    const thicknessValue = this.getThicknessValue();
    this.minDistanceBetweenFreeDrawPoints = thicknessValue / 2;

    this.drawStart(mousePos, point);
  }

  getAddedPointsWitMouse = () => {
    const reduxState = store.getState();
    const isWallsLockMode = reduxState.sqftMenuState.isWallsLockMode;
    const lastPoint = this.state.addedPoints[this.state.addedPoints.length - 1];
    let lockedPointPos = null;
    let pointsToDraw = [...this.state.addedPoints];

    //lock points to 45 deg
    if (this.isMousePosFitDistanceWithLastPoint(EventManager.LastKnownMousePos)) {
      if (isWallsLockMode ) {
        if (lastPoint) {
          lockedPointPos = getLockPointPos(lastPoint, this.state.lockedAngleStep);
          const lockPointOnField = getMousePositionOnField(lockedPointPos.x, lockedPointPos.y);
          pointsToDraw.push(lockPointOnField);
        }
      } else {
        const mousePos = EventManager.LastKnownMousePos;
        const mousePosOnField = getMousePositionOnField(mousePos.x, mousePos.y);
        pointsToDraw.push(mousePosOnField);
      }
    }

    return pointsToDraw
  }

  createFigureFromPoints(preparedPoints, shapeCenter) {
    const thicknessValue = this.getThicknessValue();
    const freeFormShapePoints = getOffsetShapePoints(preparedPoints, thicknessValue / 2, 1);

    const shape = createShapeFromFreeDrawPoints(freeFormShapePoints, shapeCenter);
    if (shape) {
      shape.setInflectionPoints(preparedPoints);
    }
  }

  addThicknessPopup = () => {
    const popupId = FREE_FORM_THICKNESS_POPUP_ID;
    const popupPosition = {left: window.innerWidth - 250, top: 50};
    const min = 1;
    const max = sqftConfig.measureUnit === MEASURE_UNITS.Metric ? 15000 : 500;
    const defaultThickness = sqftConfig.measureUnit === MEASURE_UNITS.Metric ? 660 : 26;
    const changeRotatedDegreeValuePopup = new ChangeValuePopup(
      popupId,
      min,
      max,
      () => {
        store.dispatch(deleteChangeValuePopup(popupId));
      },
      () => {
        const state = store.getState();
        const valuePopup = state.sqftMenuState.changeValuePopups.find(valuePopup => valuePopup.id === popupId);
        const value = valuePopup.value + 1;
        if (Number.parseFloat(value) && max > value && max > min) {
          store.dispatch(changeValuePopup({...valuePopup, value: value}));
        }
      },
      () => {
        const state = store.getState();
        const valuePopup = state.sqftMenuState.changeValuePopups.find(valuePopup => valuePopup.id === popupId);
        const value = valuePopup.value - 1;
        if (Number.parseFloat(value) && max > value && max > min) {
          store.dispatch(changeValuePopup({...valuePopup, value: value}));
        }
      },
      (event) => {
        const state = store.getState();
        const valuePopup = state.sqftMenuState.changeValuePopups.find(valuePopup => valuePopup.id === popupId);
        const min = valuePopup.min;
        const max = valuePopup.max;
        let value = parseImperialFractionToDecimal(event.target.value);
        value = Math.max(min, Math.min(value, max));
        //input.value = value;

        if (Number.parseFloat(value) && max > value && max > min) {
          store.dispatch(changeValuePopup({...valuePopup, value: value}));
        }
      },
      defaultThickness,
      popupPosition,
      workspace.intl.formatMessage({id: "sqft.navigation.waterfall.depth"}),
      true
    );
    store.dispatch(addChangeValuePopup(changeRotatedDegreeValuePopup));
  }

  getThicknessPopup = () => {
    const state = store.getState();
    return state.sqftMenuState.changeValuePopups.find(valuePopup => valuePopup.id === FREE_FORM_THICKNESS_POPUP_ID);
  }

  closeThicknessPopup = () => {
    const popupId = 'freeForm';
    store.dispatch(deleteChangeValuePopup(popupId));
  }

  drawAngles(ctx, points, thickness) {
    const radius = thickness * sqftConfig.scale;

    for (let i = 1; i < points.length - 1; i++) {
      const prev = points[i - 1];
      const current = points[i];
      const next = points[i + 1];
      const currentPointField = getPointField(points[i].x, points[i].y);

      const v1 = { x: current.x - prev.x, y: current.y - prev.y };
      const v2 = { x: next.x - current.x, y: next.y - current.y };

      // Angle between vectors
      const dot = v1.x * v2.x + v1.y * v2.y;
      const len1 = Math.hypot(v1.x, v1.y);
      const len2 = Math.hypot(v2.x, v2.y);
      const angleRad = Math.acos(dot / (len1 * len2));
      const angleDeg = (angleRad * 180) / Math.PI;

      // Draw
      ctx.beginPath();
      ctx.setLineDash([5, 3]);
      ctx.strokeStyle = '#c91c7b';
      ctx.arc(currentPointField.x, currentPointField.y, radius, 0, Math.PI * 2);
      ctx.stroke();
      ctx.setLineDash([]);

      const fontSize = getFontsize();
      const font = (fontSize).toString() + "px " + config.activeFontBold;
      const textX = currentPointField.x + radius + 20 * Math.cos(angleRad / 2);
      const textY = currentPointField.y - radius * Math.sin(angleRad / 2);
      const scale = sqftConfig.scale;
      const drawingCompassX = currentPointField.x + radius - 11 * scale;
      const drawingCompassY = currentPointField.y - radius + 10 * scale;

      //DrawImage.renderImageFromUrl('/images/sqft-icons/radius.svg', ctx, textX, textY, 100, 100);
      DrawImage.renderImage('icon-drawing-compass', ctx, drawingCompassX, drawingCompassY, 5, 5);

      ctx.fillStyle = '#c91c7b';

      ctx.font = font;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(angleDeg.toFixed(1) + '°', textX, textY);
    }
  }


  render = (ctx) => {
    //super.render(ctx);
    ctx.lineWidth = 2;
    ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].primary;

    const outerShapePoints = this.getAddedPointsWitMouse()
      .map(p => ({x: Math.round10(p.x, -4), y: Math.round10(p.y, -4)})); //simplify points
    if (outerShapePoints.length >= 2) {
      const thicknessValue = this.getThicknessValue();
      const offsetPoints = getOffsetShapePoints(outerShapePoints, thicknessValue / 2, 1);
      RenderFreeForm.renderShapeBetweenPoints(ctx, offsetPoints);

      ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].primary_transparent;
      ctx.fill();

      this.drawAngles(ctx, outerShapePoints, thicknessValue);
    }
  }
}
